import * as _ from "lodash";
import { Member } from "../../models/community-bereavement/member";
import { MemberRisk } from "../../models/community-bereavement/member-risk";
import LookupValue from "../../models/patient-chart/lookupValue";
import { CBMemberData } from "../../navigation/components/brief-bar/cb-member-data";
/**
 * Maps and returns CB member details mapped for BriefBar
 * @param x the incoming payload from the api
 */
function mapCBMemberToMemberDetails(x: Member): CBMemberData {
  let m = new CBMemberData();

  m.id = x.id;
  m.firstName = x.firstName;
  m.lastName = x.lastName;
  if (x.prefix != null) {
    m.prefix = x.prefix.description;
  } else {
    m.prefix = "";
  }
  if (x.suffix != null) {
    m.suffix = x.suffix.description;
  } else {
    m.suffix = "";
  }
  m.status = x.status;
  m.isActive = x.isActive;

  if (!_.isEmpty(x.memberRisks)) {
    let memberRisk: MemberRisk = _.orderBy(
      x.memberRisks,
      ["createdDatetime"],
      ["desc"]
    )[0];
    m.riskLevel = memberRisk ? memberRisk.riskScore : null;
  }

  if (x.gender) {
    let lookupValue = new LookupValue();
    if (x.gender.description === "Female") {
      lookupValue.id = 2;
      lookupValue.description = "Female";
      m.profileImagePath = "assets/mantis/female.jpg";
    } else if (x.gender.description === "Male") {
      lookupValue.id = 1;
      lookupValue.description = "Male";
      m.profileImagePath = "assets/mantis/male.jpg";
    }
    m.gender = lookupValue;
  }

  return m;
}

export { mapCBMemberToMemberDetails };



// WEBPACK FOOTER //
// ./src/mappers/community-bereavement/member-details-mapper.ts